import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/listForm/styles.scss';export default {
  "form": "_form_m5nnn_1",
  "row": "_row_m5nnn_9",
  "label": "_label_m5nnn_15",
  "button": "_button_m5nnn_21",
  "options": "_options_m5nnn_27",
  "group": "_group_m5nnn_31",
  "attribute": "_attribute_m5nnn_35",
  "addButton": "_addButton_m5nnn_46",
  "addButtonIcon": "_addButtonIcon_m5nnn_59"
};